import React, { FC, useEffect, useState } from 'react';
import Dialog, { DialogProps } from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { FileType } from 'src/types/file';
import { CloseIcon } from '../SkladonIcon/SmallIcons';
import { styled } from '@mui/system';
import translate from '@translate';
import Button from '../Button';
import { FormatedFileType, formatFile } from '../FileUpload/functions';
import getFileData from 'src/utils/getFileData';
import isSafari from 'src/utils/isSafari';

export interface FileDisplayPropsType {
    file: FileType;
    width?: string;
    height?: string;
    disableModal?: boolean;
    modal?: boolean;
    onClose?: (file: FileType) => void;
    style?: any;
}

const StyledDialog = styled(Dialog)<DialogProps>(({ theme }) => ({
    '& .MuiPaper-root': {
        height: 'calc(100% - 64px)',
    },

    '& .MuiDialogContent-root': {
        paddingTop: '40px',
    },
}));

const CloseButton = styled('div')({
    '& .MuiButton-root': {
        // float: 'right',
        position: 'absolute',
        margin: '0',
        padding: '0',
        maxWidth: 'unset',
        right: '0px',
        top: '7px',

        '& svg': {
            width: '30px',
            height: '30px',
        },
    },
});

const imgStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translateX(-50%) translateY(-50%)',
    maxWidth: '99%',
    maxHeight: '99%',
};

// todo: skontrolovat zobrazenie neulozenych a ulozenych suborov, nasledne otestovat to co uz fungovalo parseIsolatedEntityName, kde to bolo pouzite
const FileDisplay: FC<FileDisplayPropsType> = (props) => {
    const [modal, setModal] = useState(false);
    const [fileData, setFileData] = useState<FormatedFileType>();

    const handleClose = () => {
        if (!props.disableModal && props.onClose) {
            props.onClose(props.file);
            return;
        }
        setModal(false);
    };

    const openModal = () => {
        setModal(true);
    };

    const updateFileData = async (file: FileType) => {
        if (props.file.data) {
            setFileData(formatFile(props.file));
        } else {
            if (file.id) {
                const data = await getFileData(file.id);
                setFileData(formatFile({ ...props.file, data }));
            }
        }
    };

    useEffect(() => {
        if (props.file) {
            updateFileData(props.file);
        }
    }, [props.file]);

    if (!props.disableModal || modal) {
        return (
            <StyledDialog maxWidth={false} fullWidth onClose={handleClose} open>
                <CloseButton>
                    <Button variant="text" onClick={handleClose} tooltiop={translate('file.close')}>
                        <CloseIcon />
                    </Button>
                </CloseButton>
                <DialogContent>
                    <div style={{ textAlign: 'center', height: '100%' }}>
                        {fileData?.fileType === 'image' ? (
                            <div style={{ height: 600 }}>
                                <img
                                    width={props.width || fileData?.width || ''}
                                    style={{ ...imgStyle, ...props.style }}
                                    src={fileData?.data}
                                />
                            </div>
                        ) : isSafari() ? (
                            <iframe
                                src={fileData?.data}
                                height="100%"
                                width={props.width || fileData?.width || '100%'}
                                style={{ maxWidth: '100%', border: 'none', ...props.style }}
                            />
                        ) : (
                            <object
                                data={fileData?.data}
                                height="100%"
                                width={props.width || fileData?.width || '100%'}
                                style={{ maxWidth: '100%', ...props.style }}
                                type={fileData?.fileType}
                            >
                                <embed
                                    src={fileData?.data}
                                    height="100%"
                                    width={props.width || fileData?.width || '100%'}
                                    style={{ maxWidth: '100%', ...props.style }}
                                    type={fileData?.fileType}
                                />
                            </object>
                        )}
                    </div>
                </DialogContent>
            </StyledDialog>
        );
    }

    return (
        <>
            {fileData?.fileType === 'image' ? (
                <img
                    src={fileData?.data}
                    style={{ ...imgStyle, ...props.style }}
                    width={props.width || fileData?.width}
                    onClick={openModal}
                />
            ) : isSafari() ? (
                <iframe
                    src={fileData?.data}
                    height={props.height || '600px'}
                    style={{ maxWidth: '100%', border: 'none', ...props.style }}
                    width={props.width || fileData?.width}
                    onClick={openModal}
                />
            ) : (
                <object
                    data={fileData?.data}
                    height={props.height || '600px'}
                    style={{ maxWidth: '100%', ...props.style }}
                    type={fileData?.fileType}
                    width={props.width || fileData?.width}
                    onClick={openModal}
                >
                    <embed
                        src={fileData?.data}
                        height={props.height || '600px'}
                        style={{ maxWidth: '100%', ...props.style }}
                        type={fileData?.fileType}
                        width={props.width || fileData?.width}
                        onClick={openModal}
                    />
                </object>
            )}
        </>
    );
};

export default FileDisplay;
